import Sima1 from './Sima.webp'
import Sima2 from './Sima.webp'




const Simaimages =[
    Sima1, Sima2
]

export default Simaimages;